import * as React from "react";
import { observer } from "mobx-react-lite";
import { t } from "i18next";
import { MultiStepTask } from "src/components/MultiStepTask";
import { MultiStepTaskStore } from "src/components/MultiStepTask/MultiStepTaskStore";
import { MultiStepItem } from "src/components/MultiStepTask/MultiStepItem";
import { lastStep, nextStep } from "src/components/MultiStepTask/utils";
import { MultiStepEntsTable } from "src/components/MultiStepTask/utils/MultiStepEntsTable";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { Bom3CopyInStore } from "./Bom3CopyInStore";

type PropsBom3CopyIn = {
  copyStore: Bom3CopyInStore | null;
};

export const Bom3CopyIn: React.FC<PropsBom3CopyIn> = observer((props) => {
  const { copyStore } = props;

  const taskStore = React.useMemo(() => new MultiStepTaskStore(), []);

  React.useEffect(() => {
    if (copyStore) {
      taskStore.open();
    } else if (taskStore.isOpen) {
      taskStore.close();
    }
  }, [copyStore]);

  React.useEffect(() => {
    if (!taskStore.isOpen && copyStore) {
      copyStore.params.close();
    }
  }, [taskStore.isOpen]);

  const steps: MultiStepItem[] = [
    {
      title: "Модель",
      description: "Выберите, куда копировать",
      next: nextStep(copyStore?.disabled),
      drawContent: () =>
        copyStore ? (
          <MultiStepEntsTable>
            <EntityFiltersTable store={copyStore.entitiesStore} />,
          </MultiStepEntsTable>
        ) : null,
    },
  ];
  if (copyStore) {
    steps.push(
      lastStep(t("Copying"), copyStore.copyInfo, () => copyStore.copy()),
    );
  }

  return (
    <MultiStepTask title={t("Copy to")} taskStore={taskStore} steps={steps} />
  );
});
